module.exports = __webpack_public_path__ + "static/media/9DESA20.3ca10353.jpg";